import LoincIndex from '@/pages/loinc/Index'
import LoincForm from '@/pages/loinc/Form'
import LoincCSV from '@/pages/loinc/importCSV'
import LoincCSVTraducao from '@/pages/loinc/importCSVTraducoes'

const LoincRoutes = [
    {path: '/loinc', name: 'loinc.index', component: LoincIndex, meta: {permission: 'loincs.index'}},
    {path: '/loinc/create', name: 'loinc.create', component: LoincForm, meta: {permission: 'loincs.create'}},
    {path: '/loinc/edit/:id', name: 'loinc.edit', component: LoincForm, meta: {permission: 'loincs.edit'}},

    {path: '/loinc/importCSV', name: 'loinc.import.csv', component: LoincCSV, meta: {perfil: 'root'}},
    {path: '/loinc/importCSV/traducao', name: 'loinc.import.csv.traducao', component: LoincCSVTraducao, meta: {perfil: 'root'}},
];

export default LoincRoutes;